export const queryKeys = {
  blocks: {
    all: ["blocks"] as const,
    head: () => [...queryKeys.blocks.all, "head"] as const,
    winner: (height: number) => [...queryKeys.blocks.all, "winner", height] as const,
  },
  domains: {
    all: ["domains"] as const,
    registrationsSeries: (toHeight: number, fromHeight: number | null) =>
      [...queryKeys.domains.all, "registrations-series", toHeight, fromHeight] as const,
    activeMining: (windowBlocks: number) =>
      [...queryKeys.domains.all, "active-mining", windowBlocks] as const,
    leaderboardByRewards: (toHeight: number, fromHeight: number | null, limit: number) =>
      [
        ...queryKeys.domains.all,
        "leaderboard-by-rewards",
        toHeight,
        fromHeight,
        limit,
      ] as const,
  },
  domain: {
    all: ["domain"] as const,
    detail: (domainId: number, toHeight: number) =>
      [...queryKeys.domain.all, domainId, "detail", toHeight] as const,
    miningSeries: (domainId: number, toHeight: number, fromHeight: number | null) =>
      [
        ...queryKeys.domain.all,
        domainId,
        "mining-series",
        toHeight,
        fromHeight,
      ] as const,
    sentencesPage: (
      domainId: number,
      toHeight: number,
      cursor: string | null,
      limit: number | null,
    ) =>
      [
        ...queryKeys.domain.all,
        domainId,
        "sentences",
        toHeight,
        cursor,
        limit,
      ] as const,
    miningEfficiency: (domainId: number, toHeight: number, fromHeight: number | null) =>
      [
        ...queryKeys.domain.all,
        domainId,
        "mining-efficiency",
        toHeight,
        fromHeight,
      ] as const,
  },
  network: {
    all: ["network"] as const,
    miningCostSeries: (toHeight: number, fromHeight: number | null) =>
      [...queryKeys.network.all, "mining-cost-series", toHeight, fromHeight] as const,
  },
  wallet: {
    all: ["wallet"] as const,
    miningSeries: (scriptPubKey: string, toHeight: number, fromHeight: number | null) =>
      [
        ...queryKeys.wallet.all,
        scriptPubKey,
        "mining-series",
        toHeight,
        fromHeight,
      ] as const,
    sentencesPage: (
      scriptPubKey: string,
      toHeight: number,
      cursor: string | null,
      limit: number | null,
    ) =>
      [
        ...queryKeys.wallet.all,
        scriptPubKey,
        "sentences",
        toHeight,
        cursor,
        limit,
      ] as const,
    miningEfficiency: (
      scriptPubKey: string,
      toHeight: number,
      fromHeight: number | null,
    ) =>
      [
        ...queryKeys.wallet.all,
        scriptPubKey,
        "mining-efficiency",
        toHeight,
        fromHeight,
      ] as const,
    ownedDomains: (scriptPubKey: string, toHeight: number) =>
      [...queryKeys.wallet.all, scriptPubKey, "owned-domains", toHeight] as const,
    balanceSeries: (scriptPubKey: string, toHeight: number, fromHeight: number | null) =>
      [
        ...queryKeys.wallet.all,
        scriptPubKey,
        "balance-series",
        toHeight,
        fromHeight,
      ] as const,
  },
} as const;
